import { NgModule } from '@angular/core';
import { AssetsSharedModule } from '@assets/shared';

import { AppShellComponent } from './components/app-shell/app-shell.component';

@NgModule({
  imports: [
    AssetsSharedModule,
    AppShellComponent
  ],
  exports: [
    AppShellComponent
  ]
})
export class CoreModule { }
